// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

var defaultSdkConfigValue_payment_methods = [];

var defaultSdkConfigValue = {
  raw_configs: undefined,
  payment_methods: defaultSdkConfigValue_payment_methods,
  account_config: undefined,
  context_used: undefined
};

function getVaultingAction(config) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(Core__Option.flatMap(config, (function (c) {
                            return c.account_config;
                          })), (function (ac) {
                        return ac.profile;
                      })), (function (p) {
                    return p.vaulting_action;
                  })), "Skip");
}

export {
  defaultSdkConfigValue ,
  getVaultingAction ,
}
/* No side effect */
